<template>
  <div style="width: 100vw;">
    <!--    联系我们  -->

    <contactusview />

    <img
      v-if="ISphone"
      src="http://pic.midongtech.xyz/yytgw/assets/img_common_img_contact_code.png"
      style="width: 100vw;"
    />

    <div
      v-else
      class="fx-column fx-row-center"
      style=" width: 100vw;"
      :class="ISphone ? smallh2label : bigh2label"
    >
      <div style="margin-top: 5vw; font-weight: bold;">直接与我们联系</div>

      <div class="line" style="background: #0EADF2; width: 286px;height: 2px; margin-top: 20px"></div>

      <div
        class="fx-row fx-row-center fx-row-space-around"
        style="width: 90%; margin-top: 3vw; margin-bottom: 4vw;"
      >
        <div class="fx-column fx-row-center" v-for="(item, index) in dataarray1" v-bind:key="index">
          <img :src="item.iconurl" style="width: 12vw;height: 12vw;" class="hvr_grow_shadow" />
          <div style="margin-top: 2.8vw; ">{{ item.titlestr }}</div>
          <!-- fx-row-middle -->
          <div class="fx-row fx-row-center fx-row-middle" style="margin-top: 1.4vw;  ">
            <img
              style="width: 2vw;height: 2vw; margin-right:1vw; "
              src="http://pic.midongtech.xyz/yytgw/assets/img_contact_img_person.png"
            />
            <div style=" text-align: center; margin-right:1vw;">{{ item.label1 }}</div>
          </div>

          <div class="fx-row fx-row-center fx-row-middle" style="margin-top: 1.4vw;  ">
            <img
              style="width: 2vw;height: 2vw;"
              src="http://pic.midongtech.xyz/yytgw/assets/img_contact_img_mobile.png"
            />
            <div style="text-align: center;">{{ item.label2 }}</div>
          </div>

          <div class="fx-row fx-row-center fx-row-middle" style="margin-top: 1.4vw;  ">
            <img
              style="width: 2vw;height: 2vw;"
              src="http://pic.midongtech.xyz/yytgw/assets/img_contact_img_qq.png"
            />
            <div style="  text-align: center;">{{ item.label3 }}</div>
          </div>
        </div>
      </div>
    </div>

    <!--    欢迎访问  -->

    <div class="fx-column fx-row-center" style="background: #F3F4F6; width: 100vw; ">
      <div :class="ISphone ? smallh1label : bigh1label" style="margin-top: 5vw;">欢迎您的访问</div>

      <div class="blueline"></div>

      <!--   http://pic.midongtech.xyz/yytgw/assets/img_home_img_map.png   -->
      <!-- http://pic.midongtech.xyz/yytgw/assets/img_contact_img_map.png -->

      <img
        src="http://pic.midongtech.xyz/yytgw/assets/img_contact_img_map.png"
        style="width: 100vw;"
      />

      <!-- <div
        v-else
        class="mapiconview fx-column fx-row-center fx-row-middle"
        style="width: 100vw; height: 50vw; margin-top: 3vw;"
      >
        <div class="addressview fx-column fx-row-center fx-row-middle" v-if="ISphone">
          <div :class="ISphone ? smallh3label : bigh3label">020-37039757</div>
          <div :class="ISphone ? smallh3label : bigh3label">广州·海珠·琶洲</div>
        </div>
        <div class="addresspcview fx-column fx-row-center fx-row-middle" v-else>
          <div :class="ISphone ? smallh3label : bigh3label">020-37039757</div>
          <div :class="ISphone ? smallh3label : bigh3label">广州·海珠·琶洲</div>
        </div>
      </div>-->
    </div>

    <partner></partner>
    <!-- <companybtm></companybtm> -->
  </div>
</template>
<script type="text/ecmascript-6">
import contactusview from "@/components/contactusview.vue";
// import companybtm from "@/components/companybtm.vue";
import partner from "@/components/partner.vue";

export default {
  name: "ContactUs",
  components: {
    contactusview,
    // companybtm,
    partner
  },
  data() {
    return {
      ISphone: false,

      bigh1label: "bigh1label",
      bigh2label: "bigh2label",
      bigh3label: "bigh3label",
      smallh1label: "smallh1label",
      smallh2label: "smallh2label",
      smallh3label: "smallh3label",
      dataarray1: [
        {
          iconurl:
            "https://mdapnew.midongtech.xyz/uploads/20220811/47636497aabc5b9fd30dc8e863b531c2.jpg",
          titlestr: "流量变现",
          label1: "陈先生",
          label2: "18925041065",
          label3: "443007740"
        },
        {
          iconurl:
            "https://assert.yuyuetui.com/static/lADPJwKtxaVep-_NA2TNA2Q_868_868.jpg",
          titlestr: "商务合作",
          label1: "林女士",
          label2: "13322806695",
          label3: "527790796"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_contact_img_code_four.png",
          titlestr: "媒体公关",
          label1: "龙女士",
          label2: "13602480226",
          label3: "772345908"
        }
      ]
    };
  },
  mounted() {
    let w = document.documentElement.offsetWidth || document.body.offsetWidth;
    if (w < 1000) {
      this.ISphone = true;
    }

    //  this.ISphone = this.$appdata.ISphone;
  },
  methods: {
    /**
     * 点击事件
     */
    /**
     * 网络请求
     */
    /**
     * 业务方法
     */
    /**
     * 回调方法
     */
    /**
     * 页面私有方法
     */
  }
};
</script>
<style lang="less" scoped>
/*页面公共样式*/

.mapiconview {
  // background-image: ("http://pic.midongtech.xyz/yytgw/assets/img_home_img_map.png");
  // width: 100vw; height: 50vw;
  // background:url("http://pic.midongtech.xyz/yytgw/assets/img_home_img_map.png") no-repeat ;
  background-image: url("http://pic.midongtech.xyz/yytgw/assets/img_home_img_map.png");
  // background: no-repeat center top;
  background-size: contain;
}

.addressview {
  width: 25%;
  height: 20%;
  background: #161e42;
  color: white;
  border-radius: 5px;
  margin-left: 20%;
}

.addresspcview {
  width: 10%;
  height: 10%;
  background: #161e42;
  color: white;
  border-radius: 5px;
  margin-left: 20%;
}
/*头部*/

/*列表*/
</style>
